module.exports = __webpack_public_path__ + "img/Document Initiate.da7098f3.svg";